import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import MailDispatchLogsTab from "./MailDispatchLogsTab";

export default function MailDispatchLogsPage() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="p-6 bg-white dark:bg-[#18191c] rounded-2xl shadow-sm border border-gray-200 dark:border-[#212226] min-h-[60vh] flex flex-col items-center justify-center text-gray-700 dark:text-gray-300">
        <h2 className="text-xl font-bold mb-2">Erişim Reddedildi</h2>
        <p className="text-sm text-gray-500">Mail gönderim loglarını görüntülemek için lütfen giriş yapın.</p>
      </div>
    );
  }

  return (
    <div className="p-2 md:p-4">
      <MailDispatchLogsTab />
    </div>
  );
}
